import { render, staticRenderFns } from "./LoadingTo.vue?vue&type=template&id=16a8143e&"
import script from "./LoadingTo.vue?vue&type=script&lang=js&"
export * from "./LoadingTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports